import { Injectable } from '@angular/core'
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router'
import { environment } from '../../../environments/environment'

@Injectable({
  providedIn: 'root'
})
export class WidgetsGuard implements CanActivate {
  constructor(private router: Router) {}
  private readonly widgetsKey = environment.WIDGETS_KEY

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const key = route.queryParamMap.get('key')
    return key === this.widgetsKey
  }
}